import { env } from '@/env/env';

export default {
    sentryVueDns: env(process.env.VUE_APP_SENTRY_VUE_DSN, null),
    sentryTracesSampleRate: env(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE, 0),
};
